

























import { Component, Prop, Vue } from "vue-property-decorator";

import AsyncButton from "@/components/BaseAsyncButton/BaseAsyncButton.vue";
import InputRow from "@/components/InputRow/InputRow.vue";
import TextField from "@/components/TextField/TextField.vue";
import amplitude from "amplitude-js";
import { eventCodeByName, EventsNames } from "@/analytics";

@Component({
  components: {
    AsyncButton,
    InputRow,
    TextField
  }
})
export default class ClassAddStep3 extends Vue {
  @Prop({ required: true, type: Object })
  private formData!: {
    className: string;
    teachers: string;
    students: string;
  };

  @Prop({ required: true, type: Boolean })
  private loading!: boolean;

  private get rows() {
    return [
      {
        legend: this.$t("components.groupName"),
        value: this.formData.className
      },
      {
        legend: this.$t("navigation.students"),
        value: this.formData.students
      },
      {
        legend: this.$t("navigation.teachers"),
        value: this.formData.teachers
      }
    ];
  }

  private onNext() {
    amplitude
      .getInstance()
      .logEvent(
        `${eventCodeByName(EventsNames.UserClicksNextOnStep3Class)} ${
          EventsNames.UserClicksNextOnStep3Class
        }`
      );
    this.$emit("on-next");
  }
}
